import AuthService from '../services/auth.service';
import router from "@/router/router";
const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { status: { loggedIn: true }, user } : { status: { loggedIn: false }, user: null };
export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit, dispatch }) {
            console.log("store logout");
            AuthService.logout();
            commit('logout');
            dispatch("websocket/disconnect", null, {root: true})
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        }
    },
    mutations: {
        loginSuccess(state, user) {
            console.log(user);
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state) {
            console.log('login fail');
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            console.log('logout');
            state.status.loggedIn = false;
            state.user = null;
            router.push('/start');
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        }
    }
};
